import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as CouriersActions from './courier.action';
import { BannerService } from '../../shared/services/banner.service';
import { HelperService } from '../helper/helper.service';
import { SaveState } from '../../models/commonModels';
import * as CourierModel from '../../models/couriers/courier';
import { CourierService } from './courier.service';
import { saveAs } from 'file-saver';
import { StorageService } from '../../shared/services/storage.service';

export interface CourierStateModel {
    Courier: CourierModel.CourierObjectModel;
    List: CourierModel.CourierListModel;
    Delete: SaveState;
    Dictoinary: CourierModel.CourierListModel;
    ImportDPDVerificationFileStatus: any;
}

class DictionaryKeys {
  public static readonly Dictoinary = "Dictoinary";
}

@State<CourierStateModel>({
    name: 'courierState',
    defaults: {
      Courier: null,
      List: null,
      Delete: null,
      Dictoinary: null,
      ImportDPDVerificationFileStatus: false
    }
  })

  @Injectable()

  export class CourierState {

    constructor(
      private helperService: HelperService,
      private couriersService: CourierService,
      private bannerService: BannerService,
      private storageService: StorageService
    ) { }

  @Selector()
  static List(state: CourierStateModel) {
    return state.List;
  }

  @Selector()
  static Courier(state: CourierStateModel) {
    return state.Courier;
  }

  @Selector()
  static Delete(state: CourierStateModel) {
    return state.Delete;
  }

  @Selector()
  static Dictionary(state: CourierStateModel) {
    return state.Dictoinary;
  }

  @Selector()
  static ImportDPDVerificationFileStatus(state: CourierStateModel) {
    return state.ImportDPDVerificationFileStatus;
  }

  @Action(CouriersActions.Get)
  getCourier(
      context: StateContext<CourierStateModel>,
      action: CouriersActions.Get
    ) {
      context.setState(
        patch({
          Courier: null
        })
      );

      const errorMessage = 'Błąd pobierania danych o kurierze.';

      this.couriersService.getCourier(action.CourierId).subscribe((ret) => {
        if (ret.Success) {
          context.setState(
            patch({
              Courier: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
      (error) => {
        this.helperService.SaveException('CourierActions.getCourier', error);

        this.bannerService.error(errorMessage);
        });
  }

  @Action(CouriersActions.GetList)
  getList(
    context: StateContext<CourierStateModel>,
    action: CouriersActions.GetList
  ) {
    const errorMessage = 'Błąd pobierania listy kurierów';

    context.setState(
      patch({
        List: null
      })
    );

    this.couriersService.getList().subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            List: ret
          })
        );
        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('CouriersActions.getList', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(CouriersActions.Delete)
  delete(
    context: StateContext<CourierStateModel>,
    action: CouriersActions.Delete
  ) {

    const errorMessage = 'Błąd usuwania kuriera';

    this.couriersService.deleteCourier(action.CourierId).subscribe((ret) => {

      if(ret.Success)
      {
      this.bannerService.success('Kurier usunięty.');
      context.setState(
        patch({
          Delete: new SaveState(action.CourierId, true)
        })
      );
      }
      else{
        this.bannerService.error(ret.Message);
        context.setState(
          patch({
            Delete: new SaveState(action.CourierId, false)
          })
        );
      }
    },
      (error) => {
        this.helperService.SaveException('CouriersActions.getList', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(CouriersActions.Set)
  setCourier(
    context: StateContext<CourierStateModel>,
    action: CouriersActions.Set
  ) {
    const errorMessage = 'Błąd zapisu kuriera.';

    this.couriersService.setCourier(action.Courier).subscribe(
      ret => {
        if(action.Courier.CourierId)
          this.bannerService.success('Zmiany w kurierze zapisane.');
        else
          this.bannerService.success('Dodano nowego kuriera.');
        context.setState(
          patch({
            Courier: ret,
          })
        );
      },

      (error) => {
        this.helperService.SaveException('CourierActions.SetCourier', error);

        this.bannerService.error(errorMessage);
      },
      () => {});
  }

  @Action(CouriersActions.GetDictionary)
  getDictionary(
    context: StateContext<CourierStateModel>,
    action: CouriersActions.GetList
  ) {
    const errorMessage = 'Błąd pobierania słownika kurierów';

    let storageKey = DictionaryKeys.Dictoinary;

    context.setState(
      patch({
        Dictoinary: this.storageService.getItemJSON(storageKey)
      })
    );

    const state = context.getState();

    if (!state.Dictoinary) {

      this.couriersService.getDictionary().subscribe((ret) => {
        if (ret.Success) {

          context.setState(
            patch({
              Dictoinary: ret
            })
          );

          this.storageService.setItemJSON(storageKey, ret);

          return ret;

        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
        (error) => {
          this.helperService.SaveException('CouriersActions.getDictionary', error);

          this.bannerService.error(errorMessage);
        });
    }
  }

  // this action state is responsible for clear the upload form
  @Action(CouriersActions.SetImportDPDVerificationFileStatus)
  SetImportStatus(
    context: StateContext<CourierStateModel>,
    action: CouriersActions.SetImportDPDVerificationFileStatus
  ) {
    context.setState(
      patch({
        ImportDPDVerificationFileStatus: action.Status
      })
    );
  }


  @Action(CouriersActions.ImportDPDVerificationFile)
  ImportAgregatedExtended(
    context: StateContext<CourierStateModel>,
    action: CouriersActions.ImportDPDVerificationFile
  ) {

    this.bannerService.quickInfo('Rozpoczęto weryfikcaję pliku DPD, proszę czekać.');

    context.dispatch(new CouriersActions.SetImportDPDVerificationFileStatus(true));

    this.couriersService.importDPDVerification(action.Data).subscribe(ret => {

      this.helperService.consoleLog(ret.headers);

      const processed = ret.headers.get('x-import-processed');
      const error = ret.headers.get('x-import-error');
      const result = ret.headers.get('x-import-result');
      const message = ret.headers.get('x-import-message');
      const imported = Number(ret.headers.get('x-import-imported'));

      if (result === 'OK') {
        const file = new File([ret.body], `Wynik-Weryfikcacji-DPD-${this.helperService.TimeStamp()}-${action.FileName}`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        if (imported > 0) {
          this.bannerService.instantSuccess(`Zakończono weryfikację pliku <b>${action.FileName}</b><br/><b>Zaimportowano ${imported}</b> pozycji.<br/>Przetworzono <b>${processed}</b> wierszy.<br/>Znaleziono <b>${error}</b> wierszy z błędami.`);
        }
        else {
          this.bannerService.instantMessage(`Zakończono weryfikację pliku <b>${action.FileName}</b><br/><b>Nie zaimporotwano żadnych pozycji</b>.<br/>Przetworzono <b>${processed}</b> wierszy.<br/>Znaleziono <b>${error}</b> wierszy z błędami.`);
        }

        saveAs(file);
      } else {

        if (message === 'IMPORT_EXCEPTION_EMPTY_FILE') {
          this.bannerService.instantError(`Zakończono weryfikację pliku <b>${action.FileName}</b><br/>Plik przeznaczony do weryfikacji jest pusty.`);
        } else if (message === 'IMPORT_EXCEPTION_INVALID_FILE_EXTENSION') {
          this.bannerService.instantError(`Zakończono weryfikację pliku <b>${action.FileName}</b><br/>Plik przeznaczony do weryfikacji ma niewłaściwe rozszerzenie.`);
        } else if (message === 'IMPORT_EXCEPTION_INVALID_HEDER') {
          this.bannerService.instantError(`Zakończono weryfikację pliku <b>${action.FileName}</b><br/>Plik przeznaczony do weryfikacji ma niewłaściwy nagłówek.`);
        } else {
          this.bannerService.instantError(`Zakończono weryfikację pliku <b>${action.FileName}</b><br/>Wystąpił nieznany błąd podczas przetwarzania pliku.`);
        }
      }
    },
      (error) => {

        this.helperService.SaveException('CouriersActions.ImportDPDVerificationFile', error);

        this.bannerService.error('Błąd weryfikcaji pliku DPD.');

        context.dispatch(new CouriersActions.SetImportDPDVerificationFileStatus(false));
      },
      () => {
        context.dispatch(new CouriersActions.SetImportDPDVerificationFileStatus(false));
      }
    );
  }
}

